import script from "./manage-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-settings.vue?vue&type=script&setup=true&lang=js"

import "./manage-settings.vue?vue&type=style&index=0&id=216db04c&lang=scss"

const __exports__ = script;

export default __exports__